import { authLayout } from "../helpers/withAuth";

export const settingsRoutes = {
  path: "/settings/nbcu-weightage/ranking",
  ...authLayout("Dashboard", [
    {
      path: "/settings/nbcu-weightage/ranking",
      lazy: () =>
        import("../../modules/settings/ranking-page").then((m) => ({
          Component: m.RankingPage,
        })),
    },
    {
      path: "/settings/nbcu-weightage/ranking/create",
      lazy: () =>
        import("../../modules/settings/wizard/create-rank-page").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/settings/nbcu-weightage/ranking/:id",
      lazy: () =>
        import("../../modules/settings/option-edit-page").then((m) => ({
          Component: m.OptionsEditPage,
        })),
    },
  ]),
};
